module.exports = __webpack_public_path__ + "static/img/中医诊断.3482c24e.jpg";